import { type ReactNode, useId } from "react";
import { cn } from "@/utils";

export function TicketIntakeSection({
  title,
  description,
  className,
  action,
  children,
}: {
  title: string;
  description?: string;
  className?: string;
  action?: ReactNode;
  children: ReactNode;
}) {
  const titleId = useId();
  return (
    <section aria-labelledby={titleId} className={cn("flex min-w-0 flex-col gap-4", className)}>
      <header className="flex min-h-8 flex-wrap items-center justify-between gap-x-4 gap-y-2">
        <div className="flex flex-col gap-1">
          <h2 className="text-base font-medium" id={titleId}>
            {title}
          </h2>
          {description ? <p className="text-sm text-muted-foreground">{description}</p> : null}
        </div>
        {action}
      </header>
      {children}
    </section>
  );
}
